import { API_URLs } from "../../../../utilities/API_URLs";
import iAxios from "../../../../utilities/axios/axios-setup";
import { Http } from "../../../../utilities/axios/http";
import { NewRoleData, UserRolePageState } from "./_model";

export const postNewRole = (data: NewRoleData) => {
  return iAxios
    .post(API_URLs.settings.roles.postNewRole, data)
    .then((r) => {
      return r.data;
    })
    .catch((e) => {
      return null;
    });
};

export const getAccessList = (pageState: UserRolePageState) => {
  const obj: any = { ...pageState };
  Object.keys(pageState).forEach((key: any) => {
    if (key === "order") {
      console.log("The order key ");
      obj["order[" + (pageState?.order?.dataKey ?? "") + "]"] =
        pageState?.order?.order;
    } else {
      obj[key] = obj[key]?.toString();
    }
  });
  delete obj["order"];
  return iAxios
    .get(API_URLs.settings.roles.getRoles + "?" + new URLSearchParams(obj))
    .then((r) => {
      return r?.data;
    })
    .catch((e) => {
      return null;
    });
};

export const getRoleById = (id: string) => {
  return iAxios
    .get(API_URLs.settings.roles.getRoleById?.replace("{id}", id))
    .then((r) => {
      return r.data;
    })
    .catch((e) => {
      return null;
    });
};

export const deleteRoleById = (id: string) => {
  return iAxios
    .delete(API_URLs.settings.roles.deleteRoleById?.replace("{id}", id))
    .then((r) => {
      return { success: true, data: r.data };
    })
    .catch((e) => {
      return null;
    });
};

export const patchRoleById = (id: string, data: NewRoleData) => {
  return iAxios
    .patch(
      API_URLs.settings.roles.patchRoleById?.replace("{id}", id),
      { ...data, id },
      {
        headers: {
          "Content-Type": "application/merge-patch+json",
        },
      }
    )
    .then((r) => {
      return r.data;
    })
    .catch((e) => {
      return null;
    });
};

export class RoleServices {
  static getRolesList = async (params?: any) => {
    try {
      return await Http.get(API_URLs.settings.roles.rolesUrl, params);
    } catch (error) {
      return error;
    }
  };

  static createRole = async (data: any) => {
    try {
      return await Http.post(API_URLs.settings.roles.postNewRole, data);
    } catch (error) {
      return error;
    }
  };

  static getRolesMenuList = async (params?: any) => {
    try {
      return await Http.get(API_URLs.settings.roles.roleMenus, params);
    } catch (error) {
      return error;
    }
  };

  static getRoleById = async (id: number) => {
    try {
      return await Http.get(`${API_URLs.settings.roles.rolesUrl}/${id}`);
    } catch (error) {
      return error;
    }
  };

  static updateRoleById = async (data: any) => {
    try {
      return await Http.patch(API_URLs.settings.roles.rolesUrl, data);
    } catch (error) {
      return error;
    }
  };

  static deleteRole = async (id: number) => {
    try {
      return await Http.delete(`${API_URLs.settings.roles.rolesUrl}/${id}`);
    } catch (error) {
      return error;
    }
  };
}
